import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; // Import CSS

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [DBHAIOpen, setDBHAIOpen] = useState(false);
  const [myaccountOpen, setmyaccountOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <a href='/'>
          <img src="/images/logo DBH.png" alt="Data Bolta Hai Logo" />
        </a>
      </div>
      
      {/* Toggle Button for Mobile */}
      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
        <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>

        {/* Services Dropdown */}
        <li className="dropdown">
          <span onClick={() => setServicesOpen(!servicesOpen)}>
            Services ▾
          </span>
          <ul className={`dropdown-menu ${servicesOpen ? 'show' : ''}`}>
            <li><Link to="/big-data-solution" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Big Data Solution</Link></li>
            <li><Link to="/bank-data-solution" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Bank Data Solution</Link></li>
            <li><Link to="/gst-reconciliation" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>GST Reconciliation</Link></li>
            <li><Link to="/cyber-forensic" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Data Forensic</Link></li>
            <li><Link to="/call-analytics" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Call Analytics</Link></li>
            <li><Link to="/cyber-security" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Cyber Security</Link></li>
            <li><Link to ="/digital-market" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>Digital Marketing</Link></li>
          </ul>
        </li>
        <li className="dropdown">
          <span onClick={() => setDBHAIOpen(!DBHAIOpen)}>
            DBH-AI ▾
          </span>
          <ul className={`dropdown-menu ${DBHAIOpen ? 'show' : ''}`}>
            <li><Link to="//IBChatbot" onClick={() => { setMenuOpen(false); setDBHAIOpen(false); }}>IBC Chatbot</Link></li>
            <li><Link to="/RBIChatbot" onClick={() => { setMenuOpen(false); setDBHAIOpen(false); }}>RBI Chatbot </Link></li>
            {/* <li><Link to="/DBHChatbot" onClick={() => { setMenuOpen(false); setmyaccountOpen(false); }}>DBH Chatbot</Link></li> */}
          </ul>
        </li>

        <li><Link to="/media" onClick={() => setMenuOpen(false)}>Media</Link></li>
        <li><Link to="/careers" onClick={() => setMenuOpen(false)}>Careers</Link></li>
        <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>
        <li><Link to="/contact-us" onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
        <li className="dropdown">
          <span onClick={() => setmyaccountOpen(!myaccountOpen)}>
            My Account ▾
          </span>
          <ul className={`dropdown-menu ${myaccountOpen ? 'show' : ''}`}>
            <li><Link to="/my-account" onClick={() => { setMenuOpen(false); setmyaccountOpen(false); }}>Login/Signup</Link></li>
            <li><Link to="/vendor-form" onClick={() => { setMenuOpen(false); setmyaccountOpen(false); }}>Vendor Form</Link></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
